export default __webpack_public_path__ + "static/media/element_79.6884e5c7.jpg";